import { InjectionToken } from "@angular/core";
import { BalanceAdjustmentsPort } from "./balance-adjustments.port";

export const BALANCE_ADJUSTMENTS_PORT =
  new InjectionToken<BalanceAdjustmentsPort>("BALANCE_ADJUSTMENTS_PORT");
